import React from 'react';
import Button from '@material-ui/core/Button';
import ScorecardList from './ScorecardList';
import ScorecardFormDialog from './ScorecardFormDialog';
import {List} from 'immutable';
import InputField from 'components/pure/utils/form/InputField';
import FieldContainer from 'components/pure/utils/form/FieldContainer';
import SelectField from 'components/pure/utils/form/SelectField';
import './CardProfileForm.styl';
import GenericLink from 'components/GenericLink';

const required = ['name'];

export default class CardProfileFormDialog extends React.PureComponent {
  getError(property) {
    const {profile} = this.props;
    return required.indexOf(property) > -1 && (profile?.[property] || '').toString().trim() === ''
      ? 'This field is required'
      : null;
  }

  onChange(field, value) {
    this.props.onChange(this.props.profile.set(field, value));
  }

  editScorecard = scorecard => {
    this.props.EditScorecardActions.initializeForm();
    this.props.AdminScorecardActions.fetchScorecard(scorecard.id).then(scorecard =>
      this.props.CardReasonActions.fetchReasonSchemesForScoringScheme(scorecard.scoringScheme)
    );
    this.props.onToggleScorecardDialog();
  };

  createScorecard = e => {
    this.props.EditScorecardActions.initializeForm();
    this.props.onToggleScorecardDialog();
  };

  onDeleteScorecard = card => {
    const {profile} = this.props;
    const newScorecards = profile.scorecards.remove(profile.scorecards.indexOf(card));
    this.onChange('scorecards', newScorecards);
  };

  render() {
    const {profile, allScorecards, currentUser} = this.props;
    const formHasError = !!required.find(field => this.getError(field));

    const options = allScorecards
      .sortBy(card => card.name)
      .filter(
        newCard =>
          !profile?.scorecards.some(
            // Another hack.  Instead of filtering out existing
            // scoreacards by id (as they should be).  They need
            // to be filtered out by name since multiple 'cloned'
            // scorecards that are essentially identical (but
            // with different IDs) can exist.
            // Once this ticket gets finished, this can be fixed:
            // https://execvision.myjetbrains.com/youtrack/issue/EV-8413
            existingCard => existingCard.name === newCard.name
            // existingCard => existingCard.id === newCard.id
          )
      )
      .map(scorecard => ({
        label: scorecard.name,
        value: scorecard,
      }));

    const profileScorecards = profile?.scorecards?.sortBy(card => card.name) ?? List();
    return (
      <form className="card-profile-form ev-form">
        <FieldContainer
          label="Scorecard Profile Name:"
          errorOnBlur={true}
          error={this.getError('name')}>
          <InputField
            value={profile?.name || ''}
            placeholder="Scorecard Profile Name"
            focused={true}
            onChange={value => this.onChange('name', value)}
            maxLength={25}
          />
        </FieldContainer>
        {profileScorecards.size > 0 && (
          <FieldContainer label="Scorecards in this profile:" className="scorecards-in-profile">
            <ScorecardList
              scorecards={profileScorecards}
              onEditScorecard={this.editScorecard}
              onDelete={this.onDeleteScorecard}
            />
          </FieldContainer>
        )}
        {options.size > 0 && (
          <FieldContainer label="Add existing scorecard:">
            <div className="add-scorecard">
              <SelectField
                value={this.props.scorecardToAdd}
                options={options}
                hideResetButton={true}
                tether={true}
                onChange={this.props.onSelectScorecardToAdd}
              />
              {this.props.EditScorecardStore.isSaving
                ? 'Saving...'
                : this.props.scorecardToAdd && (
                    <GenericLink onClick={this.props.onAddSelectedScorecard}>add</GenericLink>
                  )}
            </div>
          </FieldContainer>
        )}
        <FieldContainer label="&nbsp;">
          <Button variant="outlined" className="ev-button" onClick={this.createScorecard}>
            Create Scorecard
          </Button>
        </FieldContainer>
        <div className="button-container">
          <Button
            variant="contained"
            color="primary"
            onClick={this.props.onSave}
            disabled={formHasError || this.props.isSaving}
            className="ev-button">
            Save
          </Button>
          <Button
            variant="outlined"
            onMouseDown={e => e.preventDefault()}
            onClick={this.props.onCancel}
            className="ev-button">
            Cancel
          </Button>
        </div>
        {this.props.showScorecardDialog && (
          <ScorecardFormDialog
            EditScorecardStore={this.props.EditScorecardStore}
            CardReasonStore={this.props.CardReasonStore}
            EditScorecardActions={this.props.EditScorecardActions}
            AdminScorecardActions={this.props.AdminScorecardActions}
            CardReasonEditStore={this.props.CardReasonEditStore}
            CardReasonEditActions={this.props.CardReasonEditActions}
            CardReasonActions={this.props.CardReasonActions}
            onRequestClose={this.props.onToggleScorecardDialog}
            currentUser={currentUser}
          />
        )}
      </form>
    );
  }
}
